import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const FAQContainer = styled.div`
  margin-bottom: 16px;
`;

const Question = styled.button`
  width: 100%;
  background-color: #1E1E1E;
  border: none;
  border-radius: 8px;
  padding: 20px 24px;
  text-align: left;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #2A2A2A;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2196F3;
  }
`;

const Icon = styled.span`
  font-size: 24px;
  transition: transform 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(45deg)' : 'rotate(0)'};
`;

const Answer = styled(motion.div)`
  background-color: #262626;
  border-radius: 0 0 8px 8px;
  margin-top: 2px;
  overflow: hidden;
  padding: 0 24px;
`;

const AnswerText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #E0E0E0;
  padding: 20px 0;
`;

const FAQ = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <FAQContainer>
      <Question 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {question}
        <Icon isOpen={isOpen}>+</Icon>
      </Question>
      
      <AnimatePresence>
        {isOpen && (
          <Answer
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <AnswerText>{answer}</AnswerText>
          </Answer>
        )}
      </AnimatePresence>
    </FAQContainer>
  );
};

export default FAQ;
